import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { actionCreators } from '@/store/ReportSubmissionGroupComments'
import EntityComments from '@/components/comments/EntityComments'

@localized()
class ReportComments extends React.Component {
  render () {
    return <EntityComments {...this.props} showExternalVisibilityCheckbox={this.props.showExternalVisibilityCheckbox} hideHeader={this.props.hideHeader} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    entityComments: state.reportSubmissionGroupComments,
    author: state.identity.user.profile.name,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getComments: actionCreators.getComments,
  addComment: actionCreators.addComment
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportComments)



// WEBPACK FOOTER //
// ./src/components/reporting/reportComments.js